/**
 * Regions, areas, districts and assemblies carry a `code`; countries carry an
 * `iso_code`; mission blocks and RMCs carry neither.
 *
 * Codes are what admins actually quote to each other when agreeing what a client may
 * reach, and titles are not unique — the same name recurs across regions, and across
 * the domestic and mission hierarchies. Folding the code into the label rather than
 * showing it in a separate column also makes it searchable, since v-select filters on
 * the label string.
 */
export default function locationLabel(row) {
  if (!row) return ''

  // countries carry `country`; every other level carries `title`
  const name = row.title || row.country || row.designation || row._id
  const code = row.code || row.iso_code

  return code ? `${name} (${code})` : String(name)
}
